export default {
  props: {
    tagName: {
      type: String,
      default: 'span',
    },
    icon: {
      type: String,
      required: true,
    },
    modBefore: Boolean,
    modAfter: Boolean,
    accessibilityText: String,
  },
  computed: {
    classes() {
      return [
        'ba-icon',
        'bi',
        `bi-${this.icon}`,
        {
          'ba-icon--before': this.modBefore,
          'ba-icon--after': this.modAfter,
        },
      ];
    },
    inputListeners() {
      const vm = this;
      return Object.assign(
        {},
        this.$listeners,
        {
          click: (event) => {
            vm.$emit('click', event.target.value);
          },
        },
      );
    },
  },
};
